import React from "react";

import table_pagination_chevron_left from "../../assets/images/icons/table_pagination_chevron_left.png";
import table_pagination_chevron_right from "../../assets/images/icons/table_pagination_chevron_right.png";

export default function TablePagination(props) {
  const {
    pageSize,
    setPageSize,
    totalRecords,
    totalPages,
    currentPage,
    setCurrentPage,
  } = props;

  const handle_next_page_click = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handle_previous_page_click = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const get_from_current_record_number = () => {
    if (totalRecords === 0) {
      return 0;
    }

    return currentPage * pageSize + 1;
  };

  const get_to_current_record_number = () => {
    if (totalRecords === 0) {
      return 0;
    }

    if (currentPage === totalPages - 1) {
      return totalRecords;
    }

    return currentPage * pageSize + pageSize;
  };

  return (
    <div className="h-[2.5rem] sm:p-2 border primary-border-color  min-w-max w-full flex flex-row justify-end gap-7 text-sm ">
      <div className="flex flex-col justify-center text-[#0000008e] ">
        Rows per Page {pageSize}
      </div>
      <div className="flex flex-col justify-center font-semibold  ">
        {`${get_from_current_record_number()}  -  ${get_to_current_record_number()} of ${totalRecords}`}
      </div>
      <div className="flex flex-row justify-center mr-2">
        <div
          className="flex flex-col justify-center  hover:cursor-pointer"
          onClick={handle_previous_page_click}
        >
          <img className="w-5 h-5" src={table_pagination_chevron_left} />
        </div>
        <div
          className="flex flex-col justify-center hover:cursor-pointer "
          onClick={handle_next_page_click}
        >
          <img src={table_pagination_chevron_right} />
        </div>
      </div>
    </div>
  );
}
